import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import './toast.css'

// COMPONENTS
import * as Icons from '@icons'

// UTILITIES
import { flatten } from '@utils/string-helper'


export interface IToast {
    type: 'default' | 'success' | 'warning' | 'error'
    text: string
}
interface Props extends React.HTMLAttributes<HTMLDivElement> {
    toast?: IToast
}

const Toast: FC<Props> = (props) => {
    const { className: classProps, toast, ...divProps } = props
    const [isOpen, setIsOpen] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (toast != null) {
            if (isOpen) setIsOpen(false)
            const enterance = setTimeout(() => { setIsOpen(true) }, 300)
            const exit = setTimeout(() => { setIsOpen(false) }, 5300)
            return () => {
                clearTimeout(enterance)
                clearTimeout(exit)
            }
        }
    }, [toast])

    const icon = useMemo(() => {
        switch (toast?.type) {
            case 'success': return <Icons.Check type="bordered" tint="var(--splitcard-green-500)" width="100%" height="100%" />
            case 'warning': return <div className="icon-bubble"><Icons.Warning tint="var(--splitcard-white)" width="60%" height="60%" /></div>
            case 'error': return <div className="icon-bubble"><Icons.Warning tint="var(--splitcard-white)" width="60%" height="60%" /></div>
            default: return null
        }
    }, [toast])

    const className = flatten('toast-container', classProps)
    const toastClassName = flatten('toast', isOpen ? 'visible' : undefined, toast?.type)

    return (
        <div className={className} {...divProps}>
            <div ref={ref} className={toastClassName}>
                {(icon != null) && <div className="icon">{icon}</div>}
                <div className="text">
                    <small>{toast?.text || ''}</small>
                </div>
            </div>
        </div>
    )
}

export default Toast